/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FontIcon } from 'react-toolbox';
import Paginate from 'components/Pagination';
import InstallSuggestionsButtons from 'installSuggestionsButtons';
import Card from 'components/Card';
import { ResourceCardElement } from 'components/ResourceCardElements';
import { getDisplayTime } from '../../../../../utils/dateUtils';
import S from './suggestions.scss';
import cardStyles from 'styles/resourceCard.scss';

class InstallSuggestionsList extends Component {
  constructor(props) {
    super(props);
    const { suggestions, totalCount } = this.props;
    const propSuggestions = suggestions || [[]];
    this.state = {
      suggestions: propSuggestions,
      totalCount,
      currentPage: 1,
      apptsByPage: propSuggestions[0],
      retryRun: false,
    };
    this.getApptsByPage = this.getApptsByPage.bind(this);
  }

  componentWillReceiveProps = (nextProps) => {
    const { suggestions, totalCount = 0 } = nextProps;
    const propSuggestions = suggestions || [[]];
    const oldSuggestions = this.props.suggestions || [[]];
    const noPropSuggestions = !propSuggestions[0].length;
    const noOldSuggestions = !oldSuggestions[0].length;
    const resetWithArgs = () => this.resetState(propSuggestions, totalCount);
    if (!(noOldSuggestions && noPropSuggestions)) {
      if ((!noOldSuggestions && noPropSuggestions) ||
               (noOldSuggestions && !noPropSuggestions)) {
        resetWithArgs();
      } else if (this.props.suggestions[0][0].opening !== propSuggestions[0][0].opening) {
        resetWithArgs();
      }
    }
  }

  componentDidUpdate = (prevProps, prevState) =>
    ((!prevState.retryRun && (
      prevProps.suggestions.length < 1 || prevState.suggestions.length < 1)
    ) ? this.setState(
      { retryRun: true }, () => this.props.rerunLoadSuggestions(),
    ) : null);

  getApptsByPage = page => this.setState({
    currentPage: page, apptsByPage: this.state.suggestions[page - 1],
  });

  resetState = (suggestions, totalCount) => this.setState({
    suggestions,
    totalCount,
    currentPage: 1,
    apptsByPage: suggestions[0] || [],
  });

  formattedTimeWindow = (startTime, endTime) => (
    `${getDisplayTime(startTime)} - ${getDisplayTime(endTime)} ${this.props.zone}`
  );

  renderSuggestionList = () => {
    const { isDeliveryList } = this.props;
    const { apptsByPage, currentPage, totalCount } = this.state;
    return (<div className={S.suggestionCard__container}>
      <section className={S.suggestionCard}>
        {isDeliveryList && this.renderButtons()}
        <div className={S.suggestionCard__title}>
          <span>Available {isDeliveryList ? 'Deliveries' : 'Installations'}</span>
        </div>
        <div className={S.suggestionCard__content}>
          {apptsByPage.map(appt => this.renderSuggestion(appt))}
        </div>
        <br />
        <div className={S.paginationContainer}>
          <Paginate
            denominator={5}
            currentPage={currentPage}
            totalCount={totalCount}
            getListPage={page => this.getApptsByPage(page)}
            buttonStyle="listPageButton"
          />
        </div>
        {!isDeliveryList && this.renderButtons()}
      </section>
    </div>);
  };

  renderSuggestion = (appt) => {
    const { suggestionKey, selectedDeliverySuggestion,
            handleSelect, isDeliveryList } = this.props;
    const { key, startTime, endTime, opening, projectedJobLength,
            projectedJobDays, assignee = { name: '' } } = appt;
    const selected = (isDeliveryList ? selectedDeliverySuggestion : suggestionKey) === key;
    return (<Card
      key={key}
      id={`appointment${key}`}
      className={cardStyles.selectableCard}
      altColor={selected}
      onClick={selected ? () => {} : () => handleSelect(appt)}
    >
      <ResourceCardElement
        title="Name"
        value={assignee.name}
        size="medium"
        theme={S}
      />
      <ResourceCardElement
        title="Start Date"
        value={opening}
        size="medium"
        theme={S}
      />
      <ResourceCardElement
        title="Arrival Window"
        value={this.formattedTimeWindow(startTime, endTime)}
        size="medium"
        theme={S}
      />
      {!isDeliveryList && <ResourceCardElement
        title="Estimated Job Length"
        value={`${projectedJobLength} hours - ${projectedJobDays} day(s)`}
        size="medium"
        theme={S}
      />}
      <div className={S.checkboxContainer}>
        <ResourceCardElement size="full">
          <FontIcon
            className={selected ? S.selectedCheckbox : S.emptyCheckbox}
            value={selected ? 'check_box' : 'check_box_outline_blank'}
          />
        </ResourceCardElement>
      </div>
    </Card>);
  }

  renderButtons = (onlyOverride = false) => (<InstallSuggestionsButtons
    position={this.props.position}
    queryStart={this.props.queryStart}
    suggestionDisableReason={this.props.suggestionDisableReason}
    handleQueryStartChange={this.props.handleQueryStartChange}
    errors={this.props.errors}
    loadCrews={this.props.rerunLoadSuggestions}
    handleSchedulingReasonChange={this.props.handleSchedulingReasonChange}
    handleSuggestionSubmit={this.props.handleSubmit}
    handleSuggestionAltSub={this.props.handleAltSub}
    overrideToCal={this.props.overrideToCal}
    schedulingReason={this.props.schedulingReason}
    suggestionKey={this.props.suggestionKey}
    onlyOverride={onlyOverride}
    isDeliveryList={this.props.isDeliveryList}
    needDelivery={this.props.needDelivery}
    surfaceType={this.props.surfaceType}
  />);

  renderNoAppointmentsMsg = () => (<Card className={S.msgCard}>
    <h5>No {this.props.isDeliveryList ? 'delivery' : 'install'} suggestions.</h5>
    {this.renderButtons(true)}
  </Card>);

  render = () => (<section>
    {this.state.suggestions[0].length > 0 ?
      this.renderSuggestionList() : this.renderNoAppointmentsMsg()}
  </section>);
}

InstallSuggestionsList.defaultProps = {
  selectedDeliverySuggestion: null, suggestionKey: null, schedulingReason: '', isDeliveryList: false,
};

InstallSuggestionsList.propTypes = {
  position: PropTypes.string.isRequired,
  zone: PropTypes.string,
  suggestions: PropTypes.array.isRequired,
  totalCount: PropTypes.number.isRequired,
  suggestionKey: PropTypes.string,
  selectedDeliverySuggestion: PropTypes.string,
  schedulingReason: PropTypes.string,
  queryStart: PropTypes.string.isRequired,
  suggestionDisableReason: PropTypes.string.isRequired,
  handleSelect: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleAltSub: PropTypes.func.isRequired,
  handleSchedulingReasonChange: PropTypes.func.isRequired,
  handleQueryStartChange: PropTypes.func.isRequired,
  rerunLoadSuggestions: PropTypes.func.isRequired,
  overrideToCal: PropTypes.func.isRequired,
  isDeliveryList: PropTypes.bool,
  needDelivery: PropTypes.bool,
  surfaceType: PropTypes.string,
  errors: PropTypes.object,
};

export default connect(() => ({}), {})(InstallSuggestionsList);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/schedule/components/installSuggestionsList.jsx